import * as React from 'react';
export var defaultManagementDefinition = {
  canEdit: false,
  editControlsMode: 'hover'
};
export var ManagementContext = React.createContext(defaultManagementDefinition);
export var ManagementProvider = ManagementContext.Provider;